<script setup lang="ts">

import { Footer } from '@components/Footer';
import { Header } from '@components/Header';
import { NavigationItems } from "@components/NavigationItems";
import { useTheme } from '@services/Theme';
import { computed, onMounted, ref } from 'vue';
import { RouterView, useRoute } from 'vue-router';

type RouteMeta = {
    section?: 'presentations'
}

const isOpen = ref( false );
const route = useRoute();
const isCarbucks = computed( () => ( route.meta as RouteMeta ).section == null );
const isPresentation = computed( () => ( route.meta as RouteMeta ).section == 'presentations' );

onMounted( () =>
{
    const theme = useTheme();
    theme.initialise();
    setTimeout( () => document.body.classList.add( 'ready' ), 1000 );
} );

</script>

<template>
    <Suspense>
        <v-layout
            id="page-scroll-container"
            class=""
            :class="{
                '!h-full !overflow-y-auto flex flex-col bg-white text-black': isCarbucks,
                'h-full flex flex-col justify-center items-stretch bg-black text-white dark': isPresentation
            }">

            <Header v-if="isCarbucks" class="z-20" />
            <RouterView v-slot="{ Component, route }" />
            <Footer v-if="isCarbucks" />

            <IconButton v-if="isCarbucks"
                        name="menu"
                        class="text-black fixed top-5 left-3 z-50 md:hidden"
                        @click.stop="() => isOpen = !isOpen" />

            <v-navigation-drawer v-if="isCarbucks"
                                v-model="isOpen"
                                location="bottom"
                                class="bg-white"
                                temporary>
                <div class="flex flex-col gap-4 p-6 text-lg font-semibold">
                    <NavigationItems :show-privacy="true" />
                </div>
            </v-navigation-drawer>

        </v-layout>
    </Suspense>
</template>
